import { render, staticRenderFns } from "./qiandao_mng.vue?vue&type=template&id=2fd38ba6&scoped=true&"
import script from "./qiandao_mng.vue?vue&type=script&lang=js&"
export * from "./qiandao_mng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd38ba6",
  null
  
)

export default component.exports